export function initHome() {
  if (
    !document.body.classList.contains('front-page') &&
    !document.body.classList.contains('home')
  ) {
    return;
  }

}
